package crashreporting

class LoggingCrashReporter(
    private val logger: CrashReporterLogger = CrashReporterLogger.Println,
) : CrashReporter {
    override fun capture(throwable: Throwable, extras: Map<String, String>) {
        logger.e("capture extras=$extras", throwable)
    }

    override fun identify(userId: String?) {
        logger.d("identify=$userId")
    }

    override fun setTag(key: String, value: String) {
        logger.d("tag $key=$value")
    }

    override fun clearUser() {
        logger.d("clearUser")
    }
}
